/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsDeleteApiKey } from "../../funcs/authServiceAccountsDeleteApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteServiceAccountApiKeyRequest$inboundSchema,
};

export const tool$authServiceAccountsDeleteApiKey: ToolDefinition<typeof args> =
  {
    name: "auth-service-accounts-delete-api-key",
    description: `Delete a service-account API key`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await authServiceAccountsDeleteApiKey(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
